import listPaginationDirective          from '../directives/listPaginationDirective.js';
import { listPaginationSearchProvider } from '../directives/listPaginationDirective.js';

angular.module( "artestListPagination", [])
	.provider(  'listPaginationSearch',          listPaginationSearchProvider )
	.directive( 'listPagination',                listPaginationDirective )
